import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseLiner24 = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6434 11.999L18.6552 6.99813C19.1123 6.54103 19.1123 5.79992 18.6552 5.34282C18.1982 4.88573 17.4572 4.88573 17.0002 5.34282L12 10.3554L6.99983 5.34282L6.99983 5.34282C6.5428 4.88573 5.8018 4.88573 5.34477 5.34282C4.88773 5.79992 4.88773 6.54103 5.34476 6.99813L10.3566 11.999L5.34476 16.9999C4.88773 17.4533 4.88471 18.1913 5.33801 18.6484C5.34025 18.6507 5.3425 18.6529 5.34476 18.6552H5.34476C5.79807 19.1123 6.53604 19.1153 6.99307 18.6619C6.99533 18.6597 6.99759 18.6574 6.99983 18.6552L12 13.6426L17.0002 18.6552V18.6552C17.4535 19.1123 18.1914 19.1153 18.6485 18.6619C18.6507 18.6597 18.653 18.6574 18.6552 18.6552C19.1123 18.2018 19.1153 17.4637 18.662 17.0066C18.6597 17.0044 18.6575 17.0021 18.6552 16.9999L13.6434 11.999Z",
    fill: "currentColor"
  })
});